import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { toast_error } from '@/libs/toast-wrappers';
import { SaveNpiProviderParams, saveNpiProvider } from '@/api/npi-preferred';
import { toError } from '@/utils/errors';

export const useSavePreferredProvider = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const request = async (params: SaveNpiProviderParams) => {
    setLoading(true);

    try {
      await saveNpiProvider(params);
      setLoading(false);
    } catch (error) {
      toast_error(t('npi-add-preferred-error'));
      setLoading(false);
      return Promise.reject(toError(error));
    }

    setLoading(false);
  };

  return { loading, request };
};
